module.exports = __webpack_public_path__ + "img/logo-smarthub.e9c5193d.svg";